module.exports = __webpack_public_path__ + "public/img/xj.aaaabe0c.png";